import script from "./DanhMucVatTuSearchInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./DanhMucVatTuSearchInput.vue?vue&type=script&lang=ts&setup=true"

import "./DanhMucVatTuSearchInput.vue?vue&type=style&index=0&id=a4f41b98&lang=css"

const __exports__ = script;

export default __exports__